import BreadcrumbComponent from '@/components/breadcrumb';

function Analytics() {
  return (
    <div className="px-4 lg:px-8 my-4 space-y-4">
      <BreadcrumbComponent title="To'lovlar ro'yxati" />

      <div>
        <h2 className="text-2xl font-bold tracking-tight">
          O'quv markaz hisbotlari
        </h2>
        <p className="text-muted-foreground">
          O'quv markazining to'lovlari va daromadlari haqida batafsil ma'lumot.
        </p>
      </div>
    </div>
  );
}

export default Analytics;
